export default "__VITE_ASSET__B8P7z6bB__"